import { LoadAndSelectAll } from './LoadAndSelectAll/LoadAndSelectAll';
import { TextWithIconsCellRenderer } from 'components/shared/data/DataGrid/renderers/cell/TextWithIcons/TextWithIcons';

export const headerRenderers = {
  selectAllHeader: LoadAndSelectAll,
  textWithIcons: TextWithIconsCellRenderer,
};

export type HeaderRenderers = typeof headerRenderers;
